import styled from 'styled-components';
import { Button } from 'reactstrap';

const UnderlinedBlueButton = styled(Button)`
  color: var(--overyield-blue);
  &:hover,
  &:focus,
  &:active {
    color: var(--overyield-blue);
    text-decoration: underline;
  }
`;

export default UnderlinedBlueButton;
